export default __webpack_public_path__ + "static/media/person-f0.bd298a36.jpeg";